import { render, staticRenderFns } from "./site-topology-change-confirmation.vue?vue&type=template&id=27a45298&"
import script from "./site-topology-change-confirmation.vue?vue&type=script&lang=js&"
export * from "./site-topology-change-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports